import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { BatteryContractReadinessDto } from "../dto/battery-contract.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

export type SendBatteryContractVariables = {
  proposalId: string
  idempotencyKey: string
}

export default function useSendBatteryContract(): UseMutationResult<
  BatteryContractReadinessDto,
  unknown,
  SendBatteryContractVariables
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, idempotencyKey }: SendBatteryContractVariables) =>
      batteryProposalService.sendContract(proposalId, { idempotencyKey }),
    onSuccess: (readiness, { proposalId }) => {
      queryClient.setQueryData(
        queryKeys.batteryProposal.contract(proposalId),
        readiness,
      )
      void queryClient.invalidateQueries({
        queryKey: queryKeys.batteryProposal.byId(proposalId),
        exact: true,
      })
    },
    onError: (_error, { proposalId }) => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.batteryProposal.contract(proposalId),
      })
    },
  })
}
